import { useState } from 'react';
import { Row } from 'react-table';
import toast from 'react-hot-toast';

import { usersDataService } from 'services/users.service';

import { useAppDispatch } from 'redux/hooks';
import { removeUser } from 'redux/slices/users';

import { routes } from 'data/routes';

import { Button } from 'components/Button';
import { DeleteModal } from 'components/DeleteModal';

import * as S from './TableActions.styles';

type TableActionsProps = {
  row: Row<{}>;
};

const defaultProps: Partial<TableActionsProps> = {};

export function TableActions(props: TableActionsProps): React.ReactElement {
  const { row } = { ...defaultProps, ...props };

  const [isModalVisible, isModalVisibleSet] = useState<boolean>();

  const { id, email } = row?.original;

  const dispatch = useAppDispatch();

  const deleteUser = () => {
    if (id) {
      usersDataService.delete(id).then(() => {
        dispatch(removeUser(id));
        isModalVisibleSet(false);
        toast.success('User deleted');
      });
    }
  };

  return (
    <S.Container>
      <Button
        $iconSize="1.6"
        asLink
        to={routes.userView(id)}
        motive="tableAction"
        iconLeft="FiEdit"
      />

      <Button
        onClick={() => isModalVisibleSet(true)}
        motive="tableActionSecondary"
        $iconSize="1.6"
        iconLeft="RiDeleteBinLine"
      />

      {isModalVisible ? (
        <DeleteModal
          onDelete={() => deleteUser()}
          name={email}
          onClose={() => isModalVisibleSet(false)}
        />
      ) : null}
    </S.Container>
  );
}
